import { lazyMerge } from '@formily/shared';
import { computed, defineComponent, inject, provide } from 'vue-demi';
import { SchemaExpressionScopeSymbol, Fragment, h } from '../shared';
export var ExpressionScope = defineComponent({
    name: 'ExpressionScope',
    props: ['value'],
    setup: function (props, _a) {
        var slots = _a.slots;
        var scopeRef = inject(SchemaExpressionScopeSymbol);
        var expressionScopeRef = computed(function () {
            return lazyMerge(scopeRef.value, props.value);
        });
        provide(SchemaExpressionScopeSymbol, expressionScopeRef);
        return function () { return h(Fragment, {}, slots); };
    },
});
//# sourceMappingURL=ExpressionScope.js.map